<template>
  <SubMenu :background-color="'black'" :items="items" />
</template>

<script>
import SubMenu from './SubMenu.vue';
export default {
  components: { SubMenu },
  props: {},
  emits: {},
  data() {
    return {
      items: [
        {
          name: 'TV Channel IGMP',
          type: 'tv',
          description: 'Test a TV Channel',
          actionUrl: {
            dvb_type: '',
            url: 'igmp://239.100.100.102:4444',
            name: 'Das Erste HD',
            serviceId: 10301,
            buildingId: 2,
            originalNetworkId: 1,
            transportStreamId: 1019,
            gateway_id: '5943e233f072299b370bbe77',
            serviceType: 'tv',
            position: 2,
            price: '0.00',
            frequency: '',
            symbolRate: '',
            tags: [],
            frequencyInKhz: '0',
            packages: ['tv-#1'],
            epgChannelId: 25,
            id: '5b1f7c4a7e521a000fa864a7',
          },
        },
        {
          name: 'Info',
          thumbnail: '/static/img/ambient/activate.png',
          description: 'Show TV Info',
          type: 'internal',
          actionUrl: '/info',
        },
        {
          name: 'Info Keyhandling',
          thumbnail: '/static/img/ambient/activate.png',
          description: 'Show TV Keyhandling',
          type: 'internal',
          actionUrl: '/info/keyhandling',
        },
        {
          name: 'Ambient Sub Menu',
          thumbnail: '/static/img/ambient/bg.png',
          description: 'Demo of the Ambient Sub menu',
          type: 'internal',
          actionUrl: '/sub-menu',
        },
        {
          name: 'Image Test',
          thumbnail: '/static/img/default.jpeg',
          description: 'Demo of image content',
          type: 'image',
          actionUrl: '/static/img/default.jpeg',
        },
        {
          name: 'Website Test',
          thumbnail: '/static/img/default.jpeg',
          description: 'Demo of website content. Showing the weather website',
          type: 'website',
          actionUrl:
            'https://stagingweatherapp.triax.biz/?c1=Paris&c2=Rom&c3=London&s=Donostia&d=4&yc=es&c1c=fr&c2c=it&c3c=gb',
        },
        // {
        //   name: 'Bundesliga Test',
        //   thumbnail: '/static/img/default.jpeg',
        //   description:
        //     'Demo of website content. Showing the Bundesliga website',
        //   type: 'website',
        //   actionUrl: 'https://stagingbundesligaapp.triax.biz',
        // },
        {
          name: 'VoD Stream',
          type: 'video',
          description: 'Test a VoD Channel',
          actionUrl:
            'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
        },
        {
          name: 'TV Channel UDP',
          type: 'tv',
          description: 'Test a TV Channel',
          actionUrl: 'udp://239.100.100.102:4444',
        },
        {
          name: 'TV Channel IGMP',
          type: 'tv',
          description: 'Test a TV Channel',
          actionUrl: {
            dvb_type: '',
            url: 'igmp://239.100.100.102:4444',
            name: 'Das Erste HD',
            serviceId: 10301,
            buildingId: 2,
            originalNetworkId: 1,
            transportStreamId: 1019,
            gateway_id: '5943e233f072299b370bbe77',
            serviceType: 'tv',
            position: 2,
            price: '0.00',
            frequency: '',
            symbolRate: '',
            tags: [],
            frequencyInKhz: '0',
            packages: ['tv-#1'],
            epgChannelId: 25,
            id: '5b1f7c4a7e521a000fa864a7',
          },
        },
        {
          name: 'Video Bunny Test (1080p)',
          description: 'Demo of video content.',
          thumbnail: '/static/img/bunny-poster.jpeg',
          //actionUrl: '/static/video/bunny.mp4',
          actionUrl: 'https://temp.digmedia.net/website/video/bigbuckbunnyclip.mp4',
          type: 'video',
        },
        {
          name: 'Video Rain Test (720p)',
          description: 'Demo of video content.',
          //actionUrl: '/static/video/rain-h264-720p.mp4',
          actionUrl: 'https://temp.digmedia.net/website/video/bigbuckbunnyclip.mp4',
          type: 'video',
        },
        {
          name: 'Reload Test',
          description: 'Reload Test',
          type: 'reload',
        },
      ],
    };
  },
  methods: {},
  computed: {},
  watch: {},
  // created: function() {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/Demo.vue